/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewdashboard1Inputs */

const en_viewdashboard1 = /** @type {(inputs: Viewdashboard1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Dashboard`)
};

const de_viewdashboard1 = /** @type {(inputs: Viewdashboard1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard öffnen`)
};

/**
* | output |
* | --- |
* | "View Dashboard" |
*
* @param {Viewdashboard1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const viewdashboard1 = /** @type {((inputs?: Viewdashboard1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewdashboard1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewdashboard1(inputs)
	return de_viewdashboard1(inputs)
});
export { viewdashboard1 as "viewDashboard" }